import { render, staticRenderFns } from "./security_patch_upgrade_alert_modal.vue.js?vue&type=template&id=0bd894e6!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./security_patch_upgrade_alert_modal.vue?vue&type=template&id=0bd894e6"
import script from "./security_patch_upgrade_alert_modal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./security_patch_upgrade_alert_modal.vue?vue&type=script&lang=js"
export * from "./security_patch_upgrade_alert_modal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./security_patch_upgrade_alert_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bd894e6')) {
      api.createRecord('0bd894e6', component.options)
    } else {
      api.reload('0bd894e6', component.options)
    }
    module.hot.accept("./security_patch_upgrade_alert_modal.vue.js?vue&type=template&id=0bd894e6!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./security_patch_upgrade_alert_modal.vue?vue&type=template&id=0bd894e6", function () {
      api.rerender('0bd894e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "gitlab_version_check/components/security_patch_upgrade_alert_modal.vue"
export default component.exports